import { Component,OnInit,ViewChild } from '@angular/core';
import { CalendarOptions} from '@fullcalendar/angular';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import swal from 'sweetalert2';  

@Component({
  selector: 'app-calendar-task',
  templateUrl: './calendar-task.component.html',
  styleUrls: ['./calendar-task.component.scss']
})
export class CalendarTaskComponent implements OnInit { 
  constructor(public authService: AuthService,public router:Router) { }
  @ViewChild('pdf_btn',null) pdf_btn;
  @ViewChild('dia_btn',null) dia_btn;
  @ViewChild('dia_btnm',null) dia_btnm;
  @ViewChild('nvatarea',null) nvatarea;

  calendarOptions: CalendarOptions = {
    initialView: 'dayGridMonth',
    dateClick: this.handleDateClick.bind(this), // bind is important!
    eventClick:this.handleEventClick.bind(this), // bind is important!
    
  };
  v_act=1;
  id_dettask=0;
  regresa_tarea(){
    this.v_act=1;
  }
  task={
    area:0,
    id:0,
    id_task:0,
    tipo:0,
    status:0,
    nombre:"",
    delega:0,
    asignadoa:0,
    asignadoa2:0,
    asignadoa3:0,
    prioridad:0,
    fini:"",
    ffin:""
  }
  tipo=-3
  tx_tarea=""
  vedt_task;
  can_dettask(){
    
  }
  gda_dettask2(){
    if(this.tx_tarea=="") return;
    if(this.tipo==0) return;
    let postData={
      task:{
        area:0,
        id:0,
        id_task:this.task.id_task,
        tipo:this.tipo,
        status:0,
        nombre:this.tx_tarea,
        delega:0,
        asignadoa:0,
        asignadoa2:0,
        asignadoa3:0,
        prioridad:0,
        fini:"",
        ffin:""
      }     
     }
     this.loading=true;
     //console.log(postData);
     this.authService.service("/api/ins_dettask",postData)
       .then(
         data => {
           this.loading=false;
           var dat = JSON.stringify(data);
           var res = JSON.parse(dat); 
           this.tx_tarea="" 
           this.fn_vertarea();           
         },
         error => {
             var de= JSON.stringify(error);
             var di = JSON.parse(de)
             this.loading=false;
             //swal.fire('¡API incorrecta..! elim_Act', '', 'error');
       });
  }
  gda_dettask(){
    
    let postData={
      task:this.task     
     }
     this.loading=true;
     //console.log(postData);
     this.authService.service("/api/ins_dettask",postData)
       .then(
         data => {
           this.loading=false;
           var dat = JSON.stringify(data);
           var res = JSON.parse(dat); 
           
           this.fn_vertarea();           
         },
         error => {
             var de= JSON.stringify(error);
             var di = JSON.parse(de)
             this.loading=false;
             //swal.fire('¡API incorrecta..! elim_Act', '', 'error');
       });
  }
  notas=[];
  iddet_task=0;
  nota_tx="";
  bndedita_task=0;
  _task={
    area:0,
    id_tarea:0,
    id_cliente:0,
    id:0,
    nombre:"",
    fecha:""
  }
  id_tarea=0;
  
  fn_nvatarea(){
    this.bndedita_task=0;
    this._task={
      area:0,
      id_tarea:this.id_tarea,
      id_cliente:Number(localStorage.getItem("id_cliente")),
      id:0,
      nombre:"",
      fecha:""
    }
  }
  gdanotas_task(){
    let postData={
      id:this.iddet_task,
      nota:this.nota_tx,
      id_usuario:localStorage.getItem("usuario")
     }
     console.log(postData)
     this.authService.service("/api/gda_notasdettask",postData)
       .then(
         data => {
           this.loading=false;
           var dat = JSON.stringify(data);
           var res = JSON.parse(dat); 
           //console.log(data);
           
           this.notas.push({id:0,Notas:this.nota_tx,fec_:"",usuario_:"yo"})
           this.nota_tx="";
         },
         error => {
             var de= JSON.stringify(error);
             var di = JSON.parse(de)
             this.loading=false;
             //console.log(di);
             //swal.fire('¡API incorrecta..! elim_Act', '', 'error');
       });
  }
  vedtnt_task(itm){
    this.iddet_task=itm.id
    let postData={
      id:itm.id,
      id_usuario:localStorage.getItem("usuario")
     }
     console.log(postData)
     this.authService.service("/api/get_notasdettask",postData)
       .then(
         data => {
           this.loading=false;
           var dat = JSON.stringify(data);
           var res = JSON.parse(dat); 
           console.log(data);
           this.notas=res;       
         },
         error => {
             var de= JSON.stringify(error);
             var di = JSON.parse(de)
       });
  }
  eli_dettask(itm){
    if(confirm("Confirm to delete this record?")==false)return;
    let postData={
      id:itm.id    
     }
     this.loading=true;
     console.log(postData);
     this.authService.service("/api/eli_dettask",postData)
       .then(
         data => {
           this.loading=false;
           var dat = JSON.stringify(data);
           var res = JSON.parse(dat); 
           this.fn_vertarea();              
         },
         error => {
             var de= JSON.stringify(error);
             var di = JSON.parse(de)
             this.loading=false;
             //swal.fire('¡API incorrecta..! elim_Act', '', 'error');
       });
  }
  edt_dettask(){
    let postData={
      task:this.task    
     }
     this.loading=true;
     console.log(postData);
     console.log("edi");
     this.authService.service("/api/upd_dettask",postData)
       .then(
         data => {
           this.loading=false;
           var dat = JSON.stringify(data);
           var res = JSON.parse(dat); 
           //console.log(data);
           this.fn_vertarea();           
         },
         error => {
             var de= JSON.stringify(error);
             var di = JSON.parse(de)
             this.loading=false;
             //console.log(di);
             //swal.fire('¡API incorrecta..! elim_Act', '', 'error');
       });
  }
  can_task(){
    //this.vtarea=2;
  }
  fn_nvodettarea(){
    this.task={
      area:0,
      id:0,
      id_task:this.task.id_task,
      tipo:0,
      status:0,
      nombre:"",
      prioridad:0,
      delega:0,
      asignadoa:0,
      asignadoa2:0,
      asignadoa3:0,
      fini:"",
      ffin:""
    }
    this.bndeditatask=0;
  }
  tarea=[];
  fn_vertarea(){
    
    
  
    let postData={
      id_task:this.id_task,     
     }
     this.loading=true;
     this.subtipos=[];
     this.agrupados=[];
     this.total_estatus=0;
     var grupos=0;
     console.log("fn_vertarea");
     console.log(postData);
     this.authService.service("/api/get_dettask",postData)
       .then(
         data => {
           this.loading=false;
           var dat = JSON.stringify(data);
           var res = JSON.parse(dat); 
           this.dettarea=res;
           console.log(res);
           var datac=Array();
           for(var i=0;i<this.dettarea.length;i++){
            if(this.dettarea[i].tipo==-1){
              this.subtipos.push(this.dettarea[i]);
            }
            if(this.dettarea[i].tipo>0){
              this.total_estatus+=this.dettarea[i].status;
              this.agrupados.push(this.dettarea[i]);
            }
            if(this.dettarea[i].tipo==-2){
              grupos=grupos+1;
              this.total_estatus+=this.dettarea[i].status;
            }
            if(this.dettarea[i].tipo>0 || this.dettarea[i].tipo==-2){
              datac.push({
                id: this.dettarea[i].id+"-",
                name: this.dettarea[i].descripcion,
                startDate: new Date(this.dettarea[i].fecha_ini),
                endDate: new Date( this.dettarea[i].fecha_fin),
                duration: 2,
                percentComplete:  this.dettarea[i].status,
                pendingReasons: null
              });
              
              
            }
           }
           console.log(this.agrupados.length+grupos)
           this.total_estatus=this.total_estatus/(this.agrupados.length+grupos);
          
           
        

         },
         error => {
             var de= JSON.stringify(error);
             var di = JSON.parse(de)
             this.loading=false;
             //swal.fire('¡API incorrecta..! elim_Act', '', 'error');
       });




  }
  subtipos=[];
  dettarea=[];
  agrupados=[];
  total_estatus=0;
  bndeditatask=0;
  handleEventClick(arg) { 
    this.v_act=2;
    var data=arg.event._def
    this.id_task=data.groupId;
    this.task.id_task=data.groupId;
    this.evento.proyecto=data.title;
    this.fn_vertarea();
    /*
       
    
    this.evento.id=data.groupId;
    this.id_dettask=data.groupId;                    
    this.dia_btnm.nativeElement.click();  
    console.log(data);
    var aa=data.title.split("/")
    console.log(aa)
    this.evento.title=aa[0];
    this.evento.proyecto=aa[1];
    this.evento.estatus=aa[2];
    this.evento.avance=aa[3];
    this.evento.id=data.groupId;
    this.id_dettask=data.groupId;                    
    this.dia_btnm.nativeElement.click();    
    */
  }
  id_task=0;
  pdf_tarea_(itm,i){
    this.id_task=itm.id;
    this.pdf_tarea(i);
  }

  pdf_tarea(id){
    //console.log("this.id_task")
   // console.log(id)
    localStorage.setItem("tipo",id.toString());
    localStorage.setItem("id_task",this.id_task.toString());
    this.router.navigate([]).then(result => {  window.open('#/fmttask', '_blank'); });    
  }
  evento={
    id: '',
    title: '', 
    proyecto:'',
    estatus:'',
    avance:'',
   
  }
  gda_task(){
    let postData = {
      task:this._task
    } 
    console.log(postData)

    this.authService.service("/api/ins_task",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);
          this.ls_eventos();
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            //swal.fire('¡API incorrecta! exp', '', 'error');
        });
  }
  edt_task(){
    let postData = {
      task:this._task
    } 
    console.log(postData)
    this.authService.service("/api/upd_task",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);
          this.ls_eventos();
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            //swal.fire('¡API incorrecta! exp', '', 'error');
        });
  }
  del_task(itm){
    if(confirm("Desea elminar el registro?")==false)return ;
    let postData = {
      id:itm.id
    } 
    this.authService.service("/api/del_task",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);
          this.ls_eventos();
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            //swal.fire('¡API incorrecta! exp', '', 'error');
        });
  }
  handleDateClick(arg) {
    var data=arg.dateStr; 
    console.log(data);

    this.fn_nvatarea()
    this.nvatarea.nativeElement.click();
    this._task.fecha=data;
    /*
    
    var datas:String= arg.dayEl.innerText
    console.log(datas);
    var aa=datas.split("\n");
    aa.splice(0, 1);
    var aux=[];
    for(var i=0;i<aa.length;i++){
      if(i%2!=0){
        aux.push(aa[i]);
      }
    }
    localStorage.setItem("events_calendar",JSON.stringify(aux))
    
    
    this.dia=arg.dateStr;                    
    this.dia_btn.nativeElement.click();
    //alert('date click! ' + arg.dateStr)
    */
  }


  bndmnugral=true;
  oculta_menu(){
    console.log("-");
    if(this.bndmnugral==true){
      this.bndmnugral=false;
    }else{
      this.bndmnugral=true;
    }
    console.log(this.bndmnugral);
  }
 
  ngOnInit() {
    this.ls_eventos();
    this.get_org();
    
    this.get_org_garoce();
  }
  get_org(){
    let postData = {
      id_cliente:localStorage.getItem("id_cliente")
    } 
      //console.log(postData);
      this.authService.service("/api/get_org",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);
            for(var i=0;i<res.length;i++){
             if(res[i].organo=='D' || res[i].organo=='P')
              this.org.push(res[i]);
            }
            console.log(this.org);
            
            this.org.sort((a,b) => a.role_card.localeCompare(b.role_card));
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta! exp', '', 'error');
          });   
    }
    org_garoce;
    org=[];
    get_org_garoce(){
      let postData = {      
      }         
        this.authService.service("/api/get_equipo_garoce",postData)
        .then(
            data => {
              var dat = JSON.stringify(data);
              var res = JSON.parse(dat);
              this.org_garoce=data;
              //console.log("orggaroce")
              //console.log(this.org_garoce);
            },
            error => {
                var de= JSON.stringify(error);
                var di = JSON.parse(de)
                swal.fire('¡API incorrecta! exp', '', 'error');
            });   
      }

  loading;
  dia=""
  pdf_evento(){
    localStorage.setItem("tipo","4");
    localStorage.setItem("dia",this.dia.toString());
    this.router.navigate([]).then(result => {  window.open('#/fmttask', '_blank'); });  
  }
 
 async ls_eventos(){    
   
    //*
    let  postData={
      id_cliente:localStorage.getItem("id_cliente")

    }  
    //await this.authService.service("/api/get_dettaskcli",postData)
    await this.authService.service("/api/get_task",postData)
    .then(
      data => {
        this.loading=false;
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat); 
        console.log("ls_eventos");
        console.log(res);
        var events=[]
        for(var i=0;i<res.length;i++){
          events.push({
            groupId: res[i].id, 
            title:res[i].titulo,
            //title: res[i].descripcion+"/"+res[i].titulo+"/"+
            // (res[i].status==100? 'Completo':res[i].vigente==0?'Vigente':'Vencido')+"/"+res[i].status+"%" , 
            start: res[i].fecha,
            end: res[i].fecha,
            color:'yellow'
            //color: res[i].status==100? 'green':res[i].vigente==0?'green':'red'
          });
          this.calendarOptions.events=events
        }
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          this.loading=false;        
    });
    //*/
  }
}
